import { render, staticRenderFns } from "./OrylShopResult.vue?vue&type=template&id=40ce8e68&scoped=true&"
import script from "./OrylShopResult.vue?vue&type=script&lang=js&"
export * from "./OrylShopResult.vue?vue&type=script&lang=js&"
import style0 from "./OrylShopResult.vue?vue&type=style&index=0&id=40ce8e68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ce8e68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VIcon,VImg,VLayout,VSimpleTable,VSpacer,VTextField})
